const getBaseURL = () => {
  return process.env.REACT_APP_API
}

export default getBaseURL
